import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import {
  Card,
  CardBody,
  Form,
  Modal,
  ModalBody,
  Input,
  FormGroup,
  ModalHeader,
  Button,
  Label,
  FormFeedback,
  Row,
} from "reactstrap"
import * as Yup from "yup"
import DeleteModel from "common/deleteModel/deleteModel"
import toast from "react-hot-toast"
import useApi from "common/ApiMiddlewere"
import ErrorModel from "common/errorModel/errorModel"
import breadcrumbs from "../../../common/Breadcrumbs"
import { useLocation } from "react-router-dom"
import { useFormik } from "formik"
import { exportDataExcel } from "components/Common/ExportData"
import StitchingMastersTable from "./StichingMastersTable"

function StitchingMasters() {
  document.title = `Stitching Masters | Raja Rani Couture`
  let { pathname } = useLocation()
  const { deleteApi, getApi, postApi, putApi } = useApi()
  // useStates
  const [modal, setModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [editData, setEditData] = useState("")
  const [tableData, setTableData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [screenLoad, setScreenLoad] = useState(false)
  const [formSumitLoading, setformSumitLoading] = useState(false)
  const [totalRecords, setTotalRecords] = useState(0)
  const [isMobile, setisMobile] = useState(window.innerWidth < 768)
  const [stitchingMasterId, setStitchingMasterId] = useState(0)
  const [isActive, setIsActive] = useState(true)

  // stitchingMaster list api
  const stitchingMasterListApi = () => {
    setScreenLoad(true)
    setIsLoading(true)
    postApi(`Common/stitching-worker-master/list`,
      {
        IsActive: isActive,
        IsStitchingWorker: false
      }).then(({ data, status }) => {
        if (status === 200) {
          setIsLoading(false)
          setTableData(data)
          setTotalRecords(data.length)
        } else {
          setIsLoading(false)
          toast.error(data, {
            style: {
              fontSize: "15px",
            },
          })
        }
        setScreenLoad(false)
      })
  }

  // stitchingMaster list api useEffect
  useEffect(() => {
    stitchingMasterListApi()
  }, [isActive])

  // toggle handlers
  const toggle = () => {
    setModal(!modal)
    validation.handleReset()
  }

  // cancle handler
  const handleCancle = () => {
    toggle()
  }

  // Delete stitchingMaster handler
  const handleDelete = (stitchingMasterId) => {
    setScreenLoad(true)
    if (stitchingMasterId) {
      DeleteModel.confirmDeleteInquiry({
        title: "Are you sure? ",
        text: "You want to delete this master permanently? ",
        isMobile,
      }).then(response => {
        if (response == true) {
          deleteApi(`Common/stitching-worker-master/delete?id=${stitchingMasterId}&isStitchingWorker=${false}`).then(
            ({ data, status }) => {
              if (status === 200) {
                const updatedArray = tableData
                  .map(obj => (obj.Id !== stitchingMasterId ? obj : null))
                  .filter(Boolean)
                setTableData(updatedArray)
                toast.success("successfully deleted", {
                  style: {
                    fontSize: "15px",
                  },
                })
              } else {
                ErrorModel.errormodel({
                  title: "Verify Master",
                  text: data,
                })
              }
              setScreenLoad(false)
            }
          )
        } else {
          setScreenLoad(false)
        }
      })
    }
  }

  // Update stitchingMaster handler
  const handleEditStitchingMaster = (stitchingMasterdata) => {
    if (stitchingMasterdata) {
      setStitchingMasterId(stitchingMasterdata.Id)
      setIsEdit(true)
      setModal(!modal)
      setEditData(stitchingMasterdata)
    }
  }

  // Create stitchingMaster handler
  const handleStitchingMasterClick = () => {
    setIsEdit(false)
    toggle()
  }

  // Stitching Masters Validation
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      Name: isEdit ? editData?.Name : "",
    },
    validationSchema: Yup.object({
      Name: Yup.string().required("The name is required"),
    }),
    onSubmit: values => {
      setformSumitLoading(true)
      if (values) {
        postApi("Common/stitching-worker-master/addedit", {
          id: isEdit ? parseInt(stitchingMasterId) : 0,
          Name: values.Name,
          IsStitchingWorker: false,
        }).then(({ data, status }) => {
          setformSumitLoading(false)
          if (status == 400) {
            toast.error(data, {
              style: {
                fontSize: "15px",
              },
            })
          } else {
            toast.success(isEdit ? "successfully updated" : "successfully created", {
              style: {
                fontSize: "15px",
              },
            })
            toggle()
            stitchingMasterListApi()
            validation.handleReset()
          }
        })
      }
    },
  })

  const handleSwitch = (id, IsActive, e) => {
    if (id) {
      putApi("Common/stitching-worker-master/active-inacive",
        {
          Id: parseInt(id),
          IsStitchingWorker: false
        }).then(({ data, status }) => {
          e.preventDefault()
          if (status === 200) {
            toast.success("Stitching Master sucessfully changed", {
              style: {
                fontSize: "15px",
              },
            })
          } else {
            $("#IsActive_" + id + "").prop("checked", IsActive)
            ErrorModel.errormodel({
              title: "Verify Stitching Master",
              text: data,
            })
          }
        })
    }
  }

  // stitchingMaster table header & accessor
  const columns = useMemo(
    () => [
      {
        Header: "Name",
        accessor: "Name",
      },
      {
        Header: () => (
          <div
            style={{
              textAlign: "center",
            }}
          >
            Is Active
          </div>
        ),
        width: "7%",
        accessor: "IsActive",
        disableSorting: true,
        Cell: ({ row }) => (
          <FormGroup switch className="d-flex justify-content-center">
            <Input
              type="switch"
              id={`IsActive_${row.original.Id}`}
              defaultChecked={row.original.IsActive}
              onClick={e => {
                handleSwitch(row.original.Id, row.original.IsActive, e)
              }}
            />
          </FormGroup>
        ),
      },
      {
        Header: () => (
          <div
            style={{
              textAlign: "center",
            }}
          >
            Action
          </div>
        ),
        width: "6%",
        accessor: "action",
        width: "8%",
        disableFilters: true,
        Cell: ({ row }) => {
          return (
            <ul className="list-unstyled hstack gap-1 mb-0 d-flex justify-content-center gap-2">
              <li className="mytooltip">
                <i
                  className=" fs-6 fas fa-edit btn-edit"
                  id={`edittooltip${row.original.Id}`}
                  onClick={() => handleEditStitchingMaster(row.original)}
                ></i>
                <span className="mytext">Edit</span>
              </li>

              <li className="mytooltip">
                <i
                  id={`deletetooltip${row.original.Id}`}
                  className="fs-6 fas fa-trash-alt btn-delete"
                  onClick={() => handleDelete(row.original.Id)}
                ></i>
                <span className="mytext">Delete</span>
              </li>
            </ul>
          )
        },
      },
    ],
    [tableData]
  )

  function writeDataToExcel() {
    setIsLoading(true)
    let header = ["Name"];
    const mainTitle = "Stitching Masters";
    const widthObj = [{
      Key: "A",
      Value: 30,
    },
    {
      Key: "B",
      Value: 18,
    },
    ]
    const extention = "Stitching_Masters.xlsx"
    let excelSheetData = []
    for (let index = 0; index < tableData.length; index++) {
      let dataObj = {
        Name: tableData[index].Name,
      }
      excelSheetData.push(dataObj)
    }
    var fields = Object.keys(excelSheetData[0]);
    var sheetData = excelSheetData.map(function (row) {
      return fields.map(function (fieldName) {
        return row[fieldName];
      });
    });
    setIsLoading(false)
    sheetData.unshift(header);
    exportDataExcel(sheetData, mainTitle, widthObj, extention)
  }

  return (
    <div className="page-content">
      <div className="container-fluid">
        {screenLoad && (
          <div className="loading-overlay is-active">
            <span className="fas fa-spinner fa-3x fa-spin"></span>
          </div>
        )}
        <Breadcrumbs
          title={breadcrumbs[pathname].title}
          breadcrumbItem={breadcrumbs[pathname].breadcrumbItem}
        />
        <Card>
          <CardBody>
            <StitchingMastersTable
              columns={columns}
              data={tableData}
              isGlobalFilter={true}
              isCategoryList={true}
              handleStitchingMasterClick={handleStitchingMasterClick}
              customPageSize={10}
              className="custom-header-css"
              isLoading={isLoading}
              TotalRecords={totalRecords}
              writeDataToExcel={writeDataToExcel}
              setIsActive={setIsActive}
              isActive={isActive}
            />

            <Modal
              isOpen={modal}
              toggle={toggle}
              centered={true}
              size="small"
              style={{ width: !isMobile ? "350px" : "" }}
            >
              <div className="modal-content">
                <ModalHeader toggle={toggle} tag="h5">
                  {isEdit ? "Update Stitching Master" : "Create Stitching Master"}
                </ModalHeader>
                <ModalBody>
                  <Form
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                    onReset={e => {
                      e.preventDefault
                      validation.handleReset()
                      return false
                    }}
                  >
                    <Row>
                      <FormGroup className="mb-2">
                        <Label htmlFor="validationCustom03" className="required">
                          Name
                        </Label>
                        <Input
                          name="Name"
                          placeholder="Stitching Master Name"
                          type="text"
                          className="form-control-sm"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.Name || ""}
                          invalid={
                            validation.touched.Name && validation.errors.Name
                              ? true
                              : false
                          }
                        />
                        {validation.touched.Name && validation.errors.Name ? (
                          <FormFeedback type="invalid">
                            {validation.errors.Name}
                          </FormFeedback>
                        ) : null}
                      </FormGroup>
                    </Row>

                    <div className="text-end">
                      {isEdit ? (
                        <Button
                          color="secondary"
                          className="btn btn-primary me-2 btn-sm"
                          onClick={handleCancle}
                        >
                          Cancle
                        </Button>
                      ) : (
                        <Button
                          color="secondary"
                          className="btn btn-primary me-2 btn-sm "
                          type="reset"
                        >
                          Reset
                        </Button>
                      )}
                      <>
                        {formSumitLoading ? (
                          <button
                            type="button"
                            className="btn btn-primary btn-sm"
                          >
                            <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                            Loading
                          </button>
                        ) : (
                          <Button
                            color="primary"
                            className="btn btn-primary btn-sm "
                            type="submit"
                          >
                            Submit
                          </Button>
                        )}
                      </>
                    </div>
                  </Form>
                </ModalBody>
              </div>
            </Modal>
          </CardBody>
        </Card>
      </div>
    </div >
  )
}
StitchingMasters.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default StitchingMasters